import React from 'react';
import { Text } from '@gasbuddy/react-components';
import { PaymentOptionPropType } from '../../prop-types/paymentOptions';
import { PaymentOptions } from '../../constants';

export default function PaymentOptionsSummary({ paymentOption }) {
  return (
    <Text as="p">
      {paymentOption === PaymentOptions.AutoPay ? 'Auto Pay' : 'Pay my statement balance manually'}
    </Text>
  );
}

PaymentOptionsSummary.propTypes = {
  paymentOption: PaymentOptionPropType,
};

PaymentOptionsSummary.defaultProps = {
  paymentOption: undefined,
};
